import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// Components
import Search from '../Search';
import SearchResults from '../Search/SearchResults';
import { SearchModeContext } from '../../../../../algolia-search/js/context/searchContext';
import EventCard from '@molecules/EventCard';

// Functionality
import { getTodayUnix } from '@general/dates';
import { SAVED_EVENTS_QUERY } from '@general/graphql/event.graph';
import { mapSearchEventToProps } from '@general/transforms/event.transform';

/**
 * Displays all the functionality of Search Upcoming Events without
 * using hooks or extra queries, expects the events array passed.
 *
 * @param Array an array of Event objects
 * @returns SearchResults Component
 */
const SearchEventsUpcomingNoQuery = ({ events }) => {
    const [filters, setFilters] = useState();

    useEffect(() => {
        if (!events) {
            return;
        }

        const expiresString = `meeting_end_timestamp >= ${getTodayUnix()}`;
        const noWebinarsString = `NOT location.address:Virtual`;

        setFilters(
            events.length === 0
                ? 'objectID:NOT-AN-EVENT'
                : `${noWebinarsString} AND ${expiresString} AND (${events
                      .map(event => `objectID:event-${event.recordId}`)
                      .join(' OR ')})`
        );
    }, [events]);

    return (
        <SearchModeContext.Provider value={{}}>
            <Search
                index="events_meeting_start_time_asc"
                filters={filters}
                defaultViewType="card"
                displayPagingToolbar={false}
                displaySearchBox={false}
                displaySearchOptions={false}
                hitsPerPage={3}
                maxWidth="auto"
            >
                <SearchResults
                    cardComponent={EventCard}
                    listItemComponent={EventCard}
                    index="events_meeting_start_time_asc"
                    query={SAVED_EVENTS_QUERY}
                    transformFunc={mapSearchEventToProps}
                    typePlural="viewerEvents"
                    NoResultsText={() => <>There are no Upcoming Events.</>}
                />
            </Search>
        </SearchModeContext.Provider>
    );
};

SearchEventsUpcomingNoQuery.propTypes = {
    events: PropTypes.array.isRequired,
};

export default SearchEventsUpcomingNoQuery;
